import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride';
import { useNavigate } from 'react-router-dom';
import { Row, Form, Tabs } from 'antd';
import dashBoardAPI from 'services/dashboard';
import Alert from 'components/Alert';
import {
  RANGE_PRESETS_DAYS,
  PREVIOUS_QUARTER,
  MONTH_NAME,
  QUARTER,
  DASHBOARD_PAGE
} from 'constants/dashboard';
import { useDispatch, useSelector } from 'react-redux';
import handleSurvey from 'utils/handleNPSSurvey';
import joyrideWelcomeCustomTooltip from 'components/JoyrideComponent/JoyrideWelcomeCustomTooltip';
import { updateNavigationTourGuide } from 'store/user';
import merchantAPI from 'services/merchants';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';
import TransactionPage from './TransactionPage';
import CommissionPage from './CommissionPage';
import { TOUR_DASHBOARD_CONTENT, QUICKSIGHT_PARTNER_ID, renderTabBarReport } from './const';
import QuicksightPage from './QuicksightPage';
import './DashBoardPage.scss';

const dayjs = require('dayjs');

const { TabPane } = Tabs;

dayjs.locale('en');

const startDate = dayjs().subtract(2, 'day');
const endDate = dayjs();

function DashBoardPage() {
  const navigate = useNavigate();
  const [transactionForm] = Form.useForm();
  const [commissionForm] = Form.useForm();
  const transactionAbortController = useRef(null);
  const commissionAbortController = useRef(null);
  const merchantAbortController = useRef(null);
  const submerchantAbortController = useRef(null);

  const [summary, setSummary] = useState({});

  const user = useSelector((state) => state?.user);
  /* eslint-disable no-underscore-dangle */
  const partnerId = user?.currentUser?.merchant_id;
  const productList = Object.values(user?.productList).map((product) => product);
  const productFilter = Object.values(user?.productList).map((product) => product?.value);

  // loader states
  const [hasSummaryData, setHasSummaryData] = useState(false);
  const [hasCommissionSummaryData, setHasCommissionSummaryData] = useState(false);
  const [commissionSummary, setCommissionSummary] = useState({});
  const [selectedMerchantTotalCounts, setSelectedMerchantTotalCounts] = useState({});
  const merchantListRef = useRef([]);
  const merchantTransactionListRef = useRef({});

  const [hasPaymentModeData, setHasPaymentModeData] = useState(false);
  const [transactionLoading, setTransactionLoading] = useState(false);
  const [paymentModeLoading, setPaymentModeLoading] = useState(false);
  const [churnGraphLoading, setChurnGraphLoading] = useState(false);
  const [topMerchantCommissionLoading, setTopMerchantCommissionLoading] = useState(false);
  const [churnTableLoading, setChurnTableLoading] = useState(false);
  const [commissionPaymentModeLoading, setcommissionPaymentModeLoading] = useState(false);
  const [defaultSelectKeys, setdefaultSelectKeys] = useState('Transaction-Report');

  //  top merchant tarnsaction graph
  const [topMerchantTransactionData, setTopMerchantTransactionData] = useState([]);
  const [topMerchantTransactionMonth, setTopMerchantTransactionMonth] = useState('');
  const [hasTopMerchantTransaction, setHasTopMerchantTransaction] = useState(false);

  // commission aggregate states
  const [commissionAggregateData, setCommissionAggregateData] = useState([]);
  const [commissionDateWise, setCommissionDateWise] = useState([]);
  const [topMerchantCommissionData, setTopMerchantCommissionData] = useState([]);
  const [topMerchantCommissionMonth, setTopMerchantCommissionMonth] = useState('');

  //  quicksight
  const [quickSightLoading, setQuickSightLoading] = useState(true);
  const [quickSightData, setQuickSightData] = useState(null);
  const [openTransactionModal, setOpenTransactionModal] = useState(false);
  const [openCommissionModal, setOpenComissionModal] = useState(false);

  // Churn Graph States
  const [churnRange, setChurnRange] = useState(PREVIOUS_QUARTER);
  const [churnGarphData, setChurnGarphData] = useState([]);
  const [churnViewMore, setChurnViewMore] = useState(false);
  const [churnTableData, setChurnTableData] = useState([]);
  const [churnGraphKeyName, setChurnGraphKeyName] = useState([]);
  const [churnTableKeyName, setChurnTableKeyName] = useState([]);
  const [churnTableParams, setChurnTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      hasNext: false
    }
  });

  const isDashboardAllowed = useSelector((state) => state.user.planPermissions.can_view_dashboard);

  // Merchant Drop Down State
  const [merchantPagination, setMerchantPagination] = useState({
    pagination: {
      current: 1,
      pageSize: 3000,
      showSizeChanger: false,
      total: 0
    }
  });
  const [merchantLoading, setMerchantLoading] = useState(false);

  const [submerchantPagination, setSubmerchantPagination] = useState({
    pagination: {
      current: 1,
      pageSize: 3000,
      showSizeChanger: false,
      total: 0
    }
  });
  const [submerchantLoading, setSubMerchantLoading] = useState(false);

  const submerchantListRef = useRef([]);
  const submerchantTransactionListRef = useRef({});
  const [selectedSubmerchantTotalCounts, setSelectedSubmerchantTotalCounts] = useState({});

  const tourGuide = useSelector((state) => state.user.navigationTourGuidetails);
  const [tourStepIndex, setTourStepIndex] = useState(1);
  const dispatch = useDispatch();

  // Transaction Graph state
  const [transactionGraphData, setTransactionGraphData] = useState({
    successRateData: [],
    paymentModeData: {}
  });
  const [tourGuideRun, setTourGuideRun] = useState(false);
  const [tourGuideSteps, setTourGuideSteps] = useState();

  const handleMenuItem = (e) => {
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: e });
    setdefaultSelectKeys(e);
  };

  const handleTransactionModelOpen = () => {
    setOpenTransactionModal(!openTransactionModal);
  };
  const handleCommissionModelOpen = () => {
    setOpenComissionModal(!openCommissionModal);
  };

  // churn Data formaters
  const formatChurnGrapObject = (object, selectedRange) => {
    let response = {};
    if (selectedRange === PREVIOUS_QUARTER) {
      response = object.map((data) => {
        let maxCount = 0;
        /* eslint-disable */
        const monthData = data?.monthly_data?.reduce(
          (acc, { year, month, total_success_count }) => {
            const monthName = MONTH_NAME[month - 1];
            acc[`${monthName}'${year}`] = total_success_count;
            maxCount = Math.max(maxCount, total_success_count);
            return acc;
          },
          {}
        );
        /* eslint-enable */
        const monthDataFormate = Object.fromEntries(
          Object.entries(monthData).map(([key, value]) => [
            key,
            { value: Math.round((value / maxCount) * 100, 2), count: value }
          ])
        );
        return {
          name: `${data.merchant_name} (${data.merchant_id})`,
          ...monthDataFormate
        };
      });
    } else {
      response = object.map((data) => {
        let maxCount = 0;
        /* eslint-disable */
        const quarterlyData = data?.quarterly_data?.reduce(
          (acc, { year, quarter_start_month, total_success_count }) => {
            const quarterName = QUARTER[quarter_start_month];
            acc[`${quarterName}'${year}`] = total_success_count;
            maxCount = Math.max(maxCount, total_success_count);
            return acc;
          },
          {}
        );
        /* eslint-enable */
        const quarterlyDataFormate = Object.fromEntries(
          Object.entries(quarterlyData).map(([key, value]) => [
            key,
            { value: Math.round((value / maxCount) * 100, 2), count: value }
          ])
        );
        return {
          name: `${data.merchant_name} (${data.merchant_id})`,
          ...quarterlyDataFormate
        };
      });
    }
    setChurnGraphKeyName(Object.keys(response?.at(0)).filter((key) => key !== 'name'));
    return response;
  };
  const formatChurnTableObject = (object) => {
    let response = {};
    if (churnRange === PREVIOUS_QUARTER) {
      response = object.map((data) => {
        /* eslint-disable */
        const monthData = data?.monthly_data.reduce((acc, { year, month, total_success_count }) => {
          const monthName = MONTH_NAME[month - 1];
          acc[`${monthName}'${year}`] = total_success_count;
          return acc;
        }, {});
        /* eslint-enable */
        return {
          name: `${data.merchant_name}`,
          id: `${data.merchant_id}`,
          ...monthData,
          churnMagnitude: `${data.churn_magnitude}`,
          churnRate: `${data.churn_rate}`
        };
      });
    } else {
      response = object.map((data) => {
        /* eslint-disable */
        const quarterlyData = data?.quarterly_data.reduce(
          (acc, { year, quarter_start_month, total_success_count }) => {
            const quarterName = QUARTER[quarter_start_month];
            acc[`${quarterName}'${year}`] = total_success_count;
            return acc;
          },
          {}
        );
        /* eslint-enable */
        return {
          name: `${data.merchant_name}`,
          id: `${data.merchant_id}`,
          ...quarterlyData,
          churnMagnitude: `${data.churn_magnitude}`,
          churnRate: `${data.churn_rate}`
        };
      });
    }
    setChurnTableKeyName(
      Object.keys(response?.at(0)).filter(
        (key) => key !== 'name' && key !== 'id' && key !== 'churnMagnitude' && key !== 'churnRate'
      )
    );
    return response;
  };
  const disabledDate = (current) => {
    const today = moment();
    const startOfCurrentMonth = today.clone().startOf('month');
    const threeMonthsAgo = startOfCurrentMonth.clone().subtract(12, 'months');
    return current.isAfter(today, 'day') || current.isBefore(threeMonthsAgo, 'day');
  };

  // Api call for graph
  const fetchMerchantList = async (pagination, filterData) => {
    if (merchantAbortController.current) merchantAbortController.current.abort();
    // Create new abort controllers
    merchantAbortController.current = new AbortController();
    if (merchantAbortController.current.signal?.aborted) return;
    setMerchantLoading(true);
    const request = {
      current: pagination?.current,
      pageSize: pagination?.pageSize,
      total: pagination?.total,
      partner_id: partnerId,
      filter: filterData
    };
    const response = await dashBoardAPI.getMerchantList(request);
    const options = [];
    if (response?.data?.data.length > 0) {
      response?.data?.data.forEach((e) => {
        options.push({
          value: e.merchant_id,
          label: e.name,
          email: e.email
        });
      });
      merchantListRef.current = [...merchantListRef.current, ...options];
    } else {
      merchantListRef.current = [...options];
    }
    setMerchantPagination({ pagination: response?.data?.pagination });
    setSelectedMerchantTotalCounts(response?.data?.pagination?.total);
    setMerchantLoading(false);
  };

  // Api call for graph
  const fetchSubmerchantList = async (pagination, filterData) => {
    if (submerchantAbortController.current) submerchantAbortController.current.abort();
    // Create new abort controllers
    submerchantAbortController.current = new AbortController();
    if (submerchantAbortController.current.signal?.aborted) return;
    setSubMerchantLoading(true);
    const request = {
      current: pagination?.current,
      pageSize: pagination?.pageSize,
      total: pagination?.total,
      partner_id: partnerId,
      filter: filterData
    };
    const response = await dashBoardAPI.getSubMerchantList(request);
    const options = [];
    if (response?.data?.data.length > 0) {
      response?.data?.data.forEach((e) => {
        options.push({
          value: e.merchant_id,
          label: e.name,
          email: e.email
        });
      });
      submerchantListRef.current = [...submerchantListRef.current, ...options];
    } else {
      submerchantListRef.current = [...options];
    }
    setSubmerchantPagination({ pagination: response?.data?.pagination });
    setSelectedSubmerchantTotalCounts(response?.data?.pagination?.total);
    setSubMerchantLoading(false);
  };

  const GraphPaymentModeSummary = async (
    payloadStartDate,
    payloadEndDate,
    payloadMerchantId,
    payloadSubmerchantId,
    payloadProducts,
    signal
  ) => {
    try {
      const filterData = await dashBoardAPI.getPaymentModeList(
        {
          start_date: payloadStartDate?.format('YYYY-MM-DD'),
          end_date: payloadEndDate?.format('YYYY-MM-DD'),
          merchant_id: payloadMerchantId,
          submerchant_id: payloadSubmerchantId,
          products: payloadProducts
        },
        { signal }
      );
      return filterData;
    } catch (error) {
      Alert('Oops!!!', `Something went wrong. Try again. ${error}`, 'error');
      throw error;
    }
  };
  const GraphSrSummary = async (
    payloadStartDate,
    payloadEndDate,
    payloadMerchantId,
    payloadSubmerchantId,
    payloadProducts,
    signal
  ) => {
    try {
      const filterData = await dashBoardAPI.getTransactionGraph(
        {
          start_date: payloadStartDate?.format('YYYY-MM-DD'),
          end_date: payloadEndDate?.format('YYYY-MM-DD'),
          merchant_id: payloadMerchantId,
          submerchant_id: payloadSubmerchantId,
          products: payloadProducts
        },
        { signal }
      );
      return filterData;
    } catch (error) {
      Alert('Oops!!!', `Something went wrong. Try again. ${error}`, 'error');
      throw error;
    }
  };
  const GraphChurnIndicator = async (selectedRange) => {
    try {
      setChurnGraphLoading(true);
      const filterData = await dashBoardAPI.getChurnMerchantList({ range: selectedRange });
      if (!filterData?.success) {
        setChurnGarphData([]);
        setChurnTableData([]);
        setChurnGraphLoading(false);
        return;
      }
      if (filterData?.data?.merchant_list?.length > 0) {
        setChurnGarphData(formatChurnGrapObject(filterData?.data?.merchant_list, selectedRange));
      }
      setChurnGraphLoading(false);
    } catch (error) {
      Alert('Oops!!!', `Something went wrong. Try again. ${error}`, 'error');
      throw error;
    }
  };

  const GraphTopMerchantCommission = async () => {
    try {
      setTopMerchantCommissionLoading(true);
      const filterData = await dashBoardAPI.getTopMerchantsCommissionGraphApi();
      if (!filterData?.success) {
        setTopMerchantCommissionData([]);
        setTopMerchantCommissionLoading(false);
        return;
      }
      setTopMerchantCommissionMonth(filterData?.data?.month);

      if (filterData?.data?.top_merchant_commission?.length > 0) {
        setTopMerchantCommissionData(filterData?.data?.top_merchant_commission);
      }
      setTopMerchantCommissionLoading(false);
    } catch (error) {
      Alert('Oops!!!', `Something went wrong. Try again. ${error}`, 'error');
      throw error;
    }
  };
  const handleTransactionGraphApi = async (
    payloadStartDate,
    payloadEndDate,
    payloadMerchantId,
    payloadSubmerchantId,
    payloadProducts,
    abortSignal
  ) => {
    setTransactionLoading(true);
    setPaymentModeLoading(true);
    setHasPaymentModeData(false);
    setHasSummaryData(false);
    if (openTransactionModal) {
      handleTransactionModelOpen();
    }

    const srData = await GraphSrSummary(
      payloadStartDate,
      payloadEndDate,
      payloadMerchantId,
      payloadSubmerchantId,
      payloadProducts,
      abortSignal
    );
    if (abortSignal?.aborted) return;
    if (!srData?.success) {
      Alert('Oops!!!', 'Something went wrong. Try again.', 'error');
      setHasSummaryData(true);
      setTransactionLoading(false);
      return;
    }
    if (srData?.data?.summary?.length > 0) {
      setHasSummaryData(true);
      setSummary(srData?.data?.summary[0]);
    }
    setTransactionGraphData((previousData) => ({
      ...previousData,
      successRateData: srData?.data?.all_data
    }));
    setTransactionLoading(false);
    if (abortSignal?.aborted) return;

    const paymentModeData = await GraphPaymentModeSummary(
      payloadStartDate,
      payloadEndDate,
      payloadMerchantId,
      payloadSubmerchantId,
      payloadProducts,
      abortSignal
    );
    if (abortSignal?.aborted) return;

    if (!paymentModeData?.success) {
      setHasPaymentModeData(false);
      setPaymentModeLoading(false);
      return;
    }
    if (paymentModeData?.data?.payment_mode?.length > 0) {
      setHasPaymentModeData(true);
      setTransactionGraphData((previousData) => ({
        ...previousData,
        paymentModeData: paymentModeData?.data?.payment_mode
      }));
      setPaymentModeLoading(false);
    }
  };
  const convertToPercentage = (data) => {
    const totalSum = data.reduce((sum, item) => sum + Math.abs(item.total), 0);

    return data.map((item) => ({
      ...item,
      percentage: totalSum === 0 ? 0 : +((item.total * 100) / totalSum).toFixed(2)
    }));
  };

  const handleCommissionGraphApi = async (
    payloadStartDate,
    payloadEndDate,
    payloadMerchantId,
    payloadSubmerchantId,
    payloadProducts,
    signal
  ) => {
    setcommissionPaymentModeLoading(true);
    if (openCommissionModal) {
      handleCommissionModelOpen();
    }
    try {
      const commissionFilterData = await dashBoardAPI.getFetchCommissionModeWiseGraph(
        {
          start_date: payloadStartDate?.format('YYYY-MM-DD'),
          end_date: payloadEndDate?.format('YYYY-MM-DD'),
          merchant_id: payloadMerchantId,
          submerchant_id: payloadSubmerchantId,
          products: payloadProducts
        },
        { signal }
      );
      if (signal?.aborted) return;

      if (!commissionFilterData?.success) {
        Alert('Oops!!!', `Something went wrong. Try again.`, 'error');
      }
      if (commissionFilterData?.data?.commission_aggregate_data?.length < 0) {
        Alert('Oops!!!', `Something went wrong. Try again.`, 'error');
        setcommissionPaymentModeLoading(false);
      }
      setCommissionAggregateData(
        convertToPercentage(commissionFilterData?.data?.commission_aggregate_data)
      );
      setCommissionDateWise(commissionFilterData?.data?.total_commission_date_wise);
      setHasCommissionSummaryData(true);
      setCommissionSummary(commissionFilterData?.data?.summary);
    } catch (error) {
      setcommissionPaymentModeLoading(false);
      Alert('Oops!!!', `Something went wrong. Try again.`, 'error');
      throw error;
    } finally {
      setcommissionPaymentModeLoading(true);
    }
    setcommissionPaymentModeLoading(false);
  };
  const filterTransactionGraphData = () => {
    const payloadMerchantId = transactionForm.getFieldValue(['dashboardMerchantId']);
    const date = transactionForm.getFieldValue(['dashboardRangePicker']);
    const payloadStartDate = date?.[0];
    const payloadEndDate = date?.[1];
    const value = transactionForm.getFieldValue(['dashboardProducts']);
    const payloadSubmerchantId = transactionForm.getFieldValue(['dashboardSubMerchantId']);
    const payloadProducts = value && value.length > 0 ? value : productFilter;
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Product Filter & Date Filter',
      Product: payloadProducts,
      Date: [payloadStartDate?.format('YYYY-MM-DD'), payloadEndDate?.format('YYYY-MM-DD')]
    });
    if (
      payloadStartDate &&
      payloadEndDate &&
      payloadProducts?.length > 0 &&
      payloadEndDate?.diff(payloadStartDate, 'days') < 31
    ) {
      if (transactionAbortController.current) transactionAbortController.current.abort();

      // Create new abort controllers
      transactionAbortController.current = new AbortController();

      handleTransactionGraphApi(
        payloadStartDate,
        payloadEndDate,
        payloadMerchantId,
        payloadSubmerchantId,
        payloadProducts,
        transactionAbortController.current.signal
      );
    }
  };

  const filterCommissionGraphData = () => {
    const payloadMerchantId = commissionForm.getFieldValue(['dashboardMerchantId']);
    const date = commissionForm.getFieldValue(['dashboardRangePicker']);
    const payloadStartDate = date?.[0];
    const payloadEndDate = date?.[1];
    const value = commissionForm.getFieldValue(['dashboardProducts']);
    const payloadProducts = value && value.length > 0 ? value : productFilter;
    const payloadSubmerchantId = transactionForm.getFieldValue(['dashboardSubMerchantId']);
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Product Filter & Date Filter',
      Product: payloadProducts,
      Date: [payloadStartDate?.format('YYYY-MM-DD'), payloadEndDate?.format('YYYY-MM-DD')]
    });
    if (
      payloadStartDate &&
      payloadEndDate &&
      payloadProducts?.length > 0 &&
      payloadEndDate?.diff(payloadStartDate, 'days') < 31
    ) {
      if (commissionAbortController.current) commissionAbortController.current.abort();

      // Create new abort controllers
      commissionAbortController.current = new AbortController();

      handleCommissionGraphApi(
        payloadStartDate,
        payloadEndDate,
        payloadMerchantId,
        payloadSubmerchantId,
        payloadProducts,
        commissionAbortController.current.signal
      );
    }
  };
  const getChurnTableData = async (pagination) => {
    try {
      setChurnTableLoading(true);
      const filterData = await dashBoardAPI.getChurnMerchantList({
        range: churnRange,
        page_size: 10,
        current_page: pagination?.current
      });
      if (!filterData?.success) {
        setChurnTableData([]);
        setChurnTableLoading(false);
        return;
      }
      if (filterData?.data?.merchant_list?.length > 0) {
        setChurnTableData(formatChurnTableObject(filterData?.data?.merchant_list));
        setChurnTableParams({
          ...churnTableParams,
          pagination: {
            ...pagination,
            total: filterData?.data?.total_count
          }
        });
        setChurnTableLoading(false);
      }
    } catch (error) {
      setChurnTableLoading(false);
      Alert('Oops!!!', `Something went wrong. Try again. ${error}`, 'error');
      throw error;
    }
  };

  const handleQuickSightApi = async () => {
    setQuickSightLoading(true);
    try {
      const quicksightResponseData = await dashBoardAPI.getFetchQuickSightApi({});
      if (!quicksightResponseData?.success) {
        Alert('Oops!!!', `Something went wrong. Try again.`, 'error');
      }
      setQuickSightData(quicksightResponseData?.data?.url);
    } catch (error) {
      Alert('Oops!!!', `Something went wrong. Try again.`, 'error');
      throw error;
    } finally {
      setQuickSightLoading(false);
    }
    setQuickSightLoading(false);
  };

  // helper function for for selecting the churn range and view more option
  const handleChurnRange = (event) => {
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: `churn range ${event.target.value}`
    });
    setChurnRange(event.target.value);
    setChurnGarphData([]);
    setChurnTableData([]);
    GraphChurnIndicator(event.target.value);
  };

  const handleChurnViewMore = (value) => {
    setChurnTableData([]);
    const defaultPageProps = {
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0
    };
    if (value) {
      setChurnTableParams({
        ...churnTableParams,
        pagination: defaultPageProps
      });
      getChurnTableData(defaultPageProps);
    }
    setChurnViewMore(value);
  };
  const handleChurnTableChange = (pagination, filters, sorter) => {
    setChurnTableData([]);
    setChurnTableParams({
      pagination,
      filters,
      ...sorter
    });
    getChurnTableData(pagination);
  };

  const fetchAndUpdateNavigation = async (paramKey) => {
    const request = {
      update: paramKey
    };
    const response = await merchantAPI.fetchNavigationFlag(request);
    if (response.success) {
      dispatch(updateNavigationTourGuide(response?.data));
    } else {
      console.log('something went wrong');
    }
  };

  const handleTopTransactionGraph = async () => {
    setHasTopMerchantTransaction(true);
    const topMerchantsTransactionGraphResponseData =
      await dashBoardAPI.getTopMerchantsTransactionGraphApi({});
    if (!topMerchantsTransactionGraphResponseData?.success) {
      setHasTopMerchantTransaction(false);
      Alert('Oops!!!', `Something went wrong. Try again.`, 'error');
    }
    setHasTopMerchantTransaction(false);
    setTopMerchantTransactionData(topMerchantsTransactionGraphResponseData?.data?.top_merchants);
    setTopMerchantTransactionMonth(
      topMerchantsTransactionGraphResponseData?.data?.top_merchants_month
    );
  };

  const handleJoyrideCallback = (callbackProps) => {
    const { status, index, action, type, size } = callbackProps;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setTourGuideRun(false);
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      setTourStepIndex(nextStepIndex);
      if (index === 1 && action === ACTIONS.NEXT) {
        handleMenuItem('Commission-Report');
      } else if (index === 2 && action === ACTIONS.PREV) {
        handleMenuItem('Transaction-Report');
      }
    }
    const lastStepIndex = size - index;
    if ([ACTIONS.CLOSE].includes(action) || [EVENTS.TOUR_END].includes(type)) {
      if (lastStepIndex > 1) {
        setTourStepIndex(size - 1);
      } else {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_dashboard_guide');
      }
    }
  };

  const resetTransactionDashboardForm = () => {
    transactionForm.setFieldsValue({
      dashboardRangePicker: [startDate, endDate], // must be dayjs or moment objects
      dashboardMerchantId: [],
      dashboardProducts: []
    });

    handleTransactionGraphApi(startDate, endDate, [], [], productFilter);
    handleSurvey(partnerId, DASHBOARD_PAGE);
  };

  const resetCommissionDashboardForm = () => {
    commissionForm.setFieldsValue({
      dashboardRangePicker: [startDate, endDate],
      dashboardMerchantId: [],
      dashboardProducts: []
    });

    handleCommissionGraphApi(startDate, endDate, [], [], productFilter);
    handleSurvey(partnerId, DASHBOARD_PAGE);
  };

  // useEffect for the fecting merchant list for drop-down adn for churn indicator
  useEffect(() => {
    if (isDashboardAllowed) {
      fetchMerchantList(merchantPagination.pagination);
      fetchSubmerchantList(submerchantPagination.pagination);
      handleTopTransactionGraph();
      trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: defaultSelectKeys });
    } else {
      navigate('/');
    }
  }, [isDashboardAllowed]);
  useEffect(() => {
    if (isDashboardAllowed) {
      GraphChurnIndicator(PREVIOUS_QUARTER);
      GraphTopMerchantCommission();
    } else {
      navigate('/');
    }
  }, [isDashboardAllowed]);

  useEffect(() => {
    if (isDashboardAllowed) {
      resetTransactionDashboardForm();
      resetCommissionDashboardForm();
      if (QUICKSIGHT_PARTNER_ID.some((element) => element === partnerId)) {
        handleQuickSightApi();
      }
    } else {
      navigate('/');
    }
  }, [isDashboardAllowed]);

  useEffect(() => {
    if (
      tourGuide?.dashboard_guide?.tour_guide &&
      tourGuide?.dashboard_guide?.dashboard_modules?.disable_dashboard_guide &&
      hasSummaryData
    ) {
      setTourGuideRun(!tourGuideRun);
      setTourGuideSteps(TOUR_DASHBOARD_CONTENT);
      setTourStepIndex(0);
    }
  }, [tourGuide, hasSummaryData]);

  return (
    <div className="dashboard-page">
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={tourGuideRun}
        steps={tourGuideSteps}
        scrollOffset={64}
        showSkipButton
        styles={{
          options: {
            primaryColor: 'var(--color-fill-alter)',
            zIndex: 100
          }
        }}
        tooltipComponent={joyrideWelcomeCustomTooltip}
        stepIndex={tourStepIndex}
      />
      <div className="dashBoard-main-container">
        <Row className="dashboard-sub-container">
          <Tabs
            type="card"
            activeKey={defaultSelectKeys}
            onChange={handleMenuItem}
            renderTabBar={renderTabBarReport}
          >
            {/*  if the className for this then it will impact the tour guide also  */}
            <TabPane
              tab="Transaction Report"
              key="Transaction-Report"
              forceRender
              className="dashboard-transaction-page"
            >
              <TransactionPage
                hasSummaryData={hasSummaryData}
                summary={summary}
                transactionLoading={transactionLoading}
                transactionGraphData={transactionGraphData}
                hasPaymentModeData={hasPaymentModeData}
                handleChurnRange={handleChurnRange}
                paymentModeLoading={paymentModeLoading}
                churnGraphLoading={churnGraphLoading}
                churnTableLoading={churnTableLoading}
                handleChurnViewMore={handleChurnViewMore}
                handleChurnTableChange={handleChurnTableChange}
                churnGarphData={churnGarphData}
                churnViewMore={churnViewMore}
                churnTableData={churnTableData}
                churnGraphKeyName={churnGraphKeyName}
                churnTableKeyName={churnTableKeyName}
                churnRange={churnRange}
                churnTableParams={churnTableParams}
                filterTransactionGraphData={filterTransactionGraphData}
                dashBoardForm={transactionForm}
                RANGE_PRESETS_DAYS={RANGE_PRESETS_DAYS}
                disabledDate={disabledDate}
                productList={productList}
                merchants={merchantListRef}
                transactionBarChartData={topMerchantTransactionData}
                transactionBarChartKey={topMerchantTransactionMonth}
                hasTopMerchantTransaction={hasTopMerchantTransaction}
                fetchMerchantList={fetchMerchantList}
                merchantLoading={merchantLoading}
                setMerchantPagination={setMerchantPagination}
                resetDashboardForm={resetTransactionDashboardForm}
                merchantTransactionListRef={merchantTransactionListRef}
                selectedMerchantTotalCounts={selectedMerchantTotalCounts}
                handleOpen={handleTransactionModelOpen}
                openModal={openTransactionModal}
                submerchants={submerchantListRef}
                fetchSubMerchantList={fetchSubmerchantList}
                submerchantLoading={submerchantLoading}
                setSubmerchantPagination={setSubmerchantPagination}
                submerchantTransactionListRef={submerchantTransactionListRef}
                selectedSubmerchantTotalCounts={selectedSubmerchantTotalCounts}
              />
            </TabPane>
            <TabPane
              tab="Commission Report"
              key="Commission-Report"
              forceRender
              className="dashboard-commission-page"
            >
              <CommissionPage
                commissionPaymentModeLoading={commissionPaymentModeLoading}
                topMerchantCommissionMonth={topMerchantCommissionMonth}
                topMerchantCommissionLoading={topMerchantCommissionLoading}
                topMerchantCommissionData={topMerchantCommissionData}
                commissionAggregateData={commissionAggregateData}
                commissionDateWise={commissionDateWise}
                filterCommissionGraphData={filterCommissionGraphData}
                dashBoardForm={commissionForm}
                RANGE_PRESETS_DAYS={RANGE_PRESETS_DAYS}
                disabledDate={disabledDate}
                hasSummaryData={hasCommissionSummaryData}
                summary={commissionSummary}
                productList={productList}
                merchants={merchantListRef}
                fetchMerchantList={fetchMerchantList}
                merchantLoading={merchantLoading}
                setMerchantPagination={setMerchantPagination}
                resetDashboardForm={resetCommissionDashboardForm}
                merchantTransactionListRef={merchantTransactionListRef}
                selectedMerchantTotalCounts={selectedMerchantTotalCounts}
                handleOpen={handleCommissionModelOpen}
                openModal={openCommissionModal}
                submerchants={submerchantListRef}
                fetchSubMerchantList={fetchSubmerchantList}
                submerchantLoading={submerchantLoading}
                setSubmerchantPagination={setSubmerchantPagination}
                submerchantTransactionListRef={submerchantTransactionListRef}
                selectedSubmerchantTotalCounts={selectedSubmerchantTotalCounts}
              />
            </TabPane>
            {QUICKSIGHT_PARTNER_ID.some((element) => element === partnerId) && (
              <TabPane
                tab="Quicksight Report"
                key="Quick-sight-Report"
                forceRender
                className="dashboard-quicksight-page"
              >
                <QuicksightPage
                  quickSightLoading={quickSightLoading}
                  quickSightData={quickSightData}
                />
              </TabPane>
            )}
          </Tabs>
        </Row>
      </div>
    </div>
  );
}
export default DashBoardPage;
